import { render, staticRenderFns } from "./b-ticket.vue?vue&type=template&id=652ee363&scoped=true"
import script from "./b-ticket.vue?vue&type=script&lang=ts"
export * from "./b-ticket.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket.vue?vue&type=style&index=0&id=652ee363&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ee363",
  null
  
)

export default component.exports